import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=ab83d9a4&"
import script from "./compose.vue?vue&type=script&lang=ts&"
export * from "./compose.vue?vue&type=script&lang=ts&"
import style0 from "./compose.vue?vue&type=style&index=0&id=ab83d9a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports